import axios from 'axios';

const getCountUpdate = async (
  countType:
    | 'notificationCount'
    | 'listingAppointmentActionCount'
    | 'listingActionCount'
    | 'coopAppointmentActionCount'
    | 'listingAgentAppointmentActionCount'
    | 'unreadConversationCount'
    | 'feedbackCount',
) => {
  const url = '/count/update';
  const { data } = await axios.get(url, {
    params: {
      countType,
    },
  });

  return data;
};

export default getCountUpdate;
